import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { removeSnackbarAction } from '../../store/snackbar/actions';
import { AppState } from '../../store';

let displayedNotifications: any[] = [];

const storeDisplayedNotification = (id: string) => {
  displayedNotifications = [...displayedNotifications, id];
};

const SnackbarNotifier = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state: AppState) => state.snackbar.notifications);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    notifications.forEach(({ key, message, options = {}, dismissed = false }) => {
      if (dismissed) {
        closeSnackbar(key);
      }

      if (!displayedNotifications.includes(key)) {
        enqueueSnackbar(message, {
          key,
          ...options,
          onClose: (event: Event, reason: string, notificationKey: string) => {
            if (options.onClose) {
              options.onClose(event, reason, notificationKey);
            }
          },
          onExited: (event: Event, notificationKey: string) => {
            dispatch(removeSnackbarAction(notificationKey));
          },
        });
      }
      storeDisplayedNotification(key);
    });
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

  return null;
};

export default SnackbarNotifier;
